// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { AuthBaseEntity } from '../auth-base-entity';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class License extends AuthBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  active!: boolean;
  createdAt!: Date;
  createdBy?: string;
  endOfLicense!: Date;
  practiceId!: number;
  productId!: number;
  startOfLicense!: Date;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  licensedProduct!: Product;
}

